<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <cerrix-pcs [config]="selectorConfig"></cerrix-pcs>
}
